import React from 'react';

export default function CtaBanner() {
  return (
    <section id="contact" className="kh-container" style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px 100px' }}>
      <div className="kh-cta-panel">
        <div>
          <h2 style={{ fontSize: 30, fontWeight: 700, color: '#0B1440' }}>Have a project in mind?</h2>
          <p style={{ fontSize: 15.5, color: '#3A2405', marginTop: 10, fontWeight: 500 }}>
            Let's turn it into a product &mdash; talk to our team today.
          </p>
        </div>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
          <a href="tel:0717123790" className="kh-cta-btn kh-cta-btn-solid">
            <svg width="16" height="16"><use href="#i-phone" /></svg>Call Us
          </a>
          <a href="https://wa.me/94717123790" target="_blank" rel="noopener noreferrer" className="kh-cta-btn kh-cta-btn-outline">
            <svg width="16" height="16"><use href="#i-wa" /></svg>WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
